const base64ToBlob = (base64Data: string, mimeType: string): Blob => {
    const byteString = window.atob(base64Data);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], { type: mimeType });
};

const blobToFile = (blobData: Blob, fileName: string, mimeType: string): File => {
    return new File([blobData], fileName, { type: mimeType });
}

/**
 * Converts a Base64-encoded JPEG string to a File object
 * 
 * @param base64JPEG 
 * @param fileName 
 * @returns 
 */
export const base64JPEGToFile = (base64JPEG: string, fileName: string): File => {
    const jpegMimeType = 'image/jpeg';
    return blobToFile(base64ToBlob(base64JPEG, jpegMimeType), fileName, jpegMimeType);
}
